import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home";

import Profile from "../views/user/Profile";
import EditProfile from "../views/user/EditProfile";

import CompanyLocationList from "../views/company/location/List";
import CompanyLocationCreate from "../views/company/location/Create";
import CompanyLocationEdit from "../views/company/location/Edit";
import CompanyListManage from "../views/company/list/Manage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },

  // profile
  {
    path: "/profilo",
    name: "profile",
    component: Profile,
    meta: { auth: true }
  },
  {
    path: "/profilo/modifica",
    name: "profile.edit",
    component: EditProfile,
    meta: { auth: true }
  },

  // auth
  {
    path: "/login",
    name: "auth.login",
    component: () =>
      import(/* webpackChunkName: "auth.login" */ "../views/auth/Login"),
    props: true,
    replace: true // Don't leave trace in history
  },
  {
    path: "/reset-password",
    name: "auth.resetPassword",
    component: () =>
      import(
        /* webpackChunkName: "auth.resetPassword" */ "../views/auth/ResetPassword"
      )
  },
  {
    path: "/conferma-account",
    name: "auth.confirmAccount",
    component: () =>
      import(
        /* webpackChunkName: "auth.confirmAccount" */ "../views/auth/ConfirmAccount"
      )
  },

  // company
  {
    path: "/registrazione",
    name: "auth.register",
    component: () =>
      import(
        /* webpackChunkName: "company.register" */ "../views/auth/Register"
      )
  },
  {
    path: "/attivita",
    name: "company.location.list",
    component: CompanyLocationList,
    meta: { auth: true }
  },
  {
    path: "/attivita/crea",
    name: "company.location.create",
    component: CompanyLocationCreate,
    meta: { auth: true }
  },
  {
    path: "/attivita/:location/modifica",
    name: "company.location.edit",
    component: CompanyLocationEdit,
    meta: { auth: true }
  },
  {
    path: "/lista/:location",
    name: "company.list.manage",
    component: CompanyListManage,
    meta: { auth: true }
  }
];

const router = new VueRouter({
  routes
});

export default router;
